import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { removeDefaultParams } from '../../../Utils/helper';
import { StrikePrice } from '../ProductDetail/styled';
import { fireBundleEventHandler } from './instrumentation';
import {
  BundleContainer,
  DiscountStyle,
  PackInfo,
  PackPrice,
  PPUText,
  Price,
  TitleWrapper,
  VariantData,
  VariantFeature,
  VariantTag,
  VariantTitle,
} from './styled';
import { queryParamHandling } from '../../../Utils/productPageUtils';
import Image from 'next/image';
import Cookies from 'js-cookie';

function HealthBundleInner(props) {
  const {
    productId,
    element,
    index,
    isFertilityProduct,
    bundleRef,
    lactoMama,
    lactoMamaCategory,
    setSelectedVariant,
    productPriceData,
    setAddProductToCartOnVariantClick,
    stretchMarks,
    handleClose,
    isPopUp,
    isDetergentProduct,
    userType,
  } = props;

  ///  element.strikePrice = 4999;
  const [cardEffect, setCardEffect] = useState(false);
  const [mobileView, setMobileView] = useState(true);
   const [isClient, setIsClient] = useState(false); // Track if we're on client

  const router = useRouter();
  const onClickHandler = (e, element) => {
    e.preventDefault();
    fireBundleEventHandler(element);
    setCardEffect(true);
    const { addParams, newUrl } = queryParamHandling(element?.web_url);
    if (lactoMamaCategory) {
      setSelectedVariant(element?.id);
      setTimeout(() => {
        setCardEffect(false);
      }, [200]);

      let clicks = Cookies.get(`click_variant_${element.id}`) || 1;
      if (clicks > 1) {
        setAddProductToCartOnVariantClick(true);
        if (isPopUp) {
          handleClose();
        }
      } else {
        clicks++;
        Cookies.set(`click_variant_${element.id}`, clicks);
      }
    } else {
      setTimeout(() => {
        router.replace(newUrl + addParams, '');
        setCardEffect(false);
      }, [200]);
    }
  };

  let hideStrikeprice, discountPercent;

  if (productPriceData) {
    hideStrikeprice =
      productPriceData?.strikeprice - productPriceData?.price === 0;
    discountPercent = Math.floor(
      ((productPriceData?.strikeprice - productPriceData?.price) /
        productPriceData?.strikeprice) *
        100,
    );
  } else {
    hideStrikeprice = element?.strikePrice - element?.price === 0;
    discountPercent = Math.floor(
      ((element?.strikePrice - element?.price) / element?.strikePrice) * 100,
    );
  }
  const getVariantFeatures = (type) => {
     // Only render after client-side hydration is complete
    if (!isClient) return null;
    return typeof window !== 'undefined' &&
      ((window.innerWidth > 720 && type == 'side') ||
        ((window.innerWidth < 720 || typeof window == 'undefined') &&
          type == 'top')) ? (
      <VariantFeature>
        {element?.variantFeature?.length
          ? element?.variantFeature?.map((innerElement, index) => {
              return <li key={`feature${index}`}>{innerElement.feature}</li>;
            })
          : null}
      </VariantFeature>
    ) : null;
  };

  useEffect(() => {
    setIsClient(true);
    const updateView = () => {
      if (window.innerWidth < 720) {
        setMobileView(true);
      } else if (window.innerWidth > 720) {
        setMobileView(false);
      }
    };
    // Run once on mount
    updateView();

    // Add a resize listener
    window.addEventListener('resize', updateView);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', updateView);
  }, []); // No window dependency here, safe for SSR

  useEffect(() => {
    if (isFertilityProduct) {
      const scrollContainer = bundleRef.current;
      let scrollDistance =
        productId == 3663
          ? -scrollContainer?.clientWidth
          : 3408
            ? scrollContainer?.clientWidth / 3
            : scrollContainer?.clientWidth;
      scrollContainer.scrollLeft += scrollDistance;
    }
  }, [productId]);
  return (
    <Link
      href={{
        pathname: element?.web_url,
        query: removeDefaultParams(router.query),
      }}
      passHref
      locale={false}
      key={`bundle_${index}`}
      legacyBehavior
    >
      <BundleContainer
        as="a"
        className={cardEffect ? 'lowOpacity' : ''}
        onClick={(e) => {
          onClickHandler(e, element);
        }}
        selected={productId === element?.id}
        isFertilityProduct={isFertilityProduct}
        id={'bundle' + element?.id}
        lactoMama={lactoMama}
        lactoMamaCategory={lactoMamaCategory}
        stretchMarks={stretchMarks}
      >
        {isFertilityProduct ? (
          <>
            <VariantTitle selected={productId === element?.id}>
              {/* <span
                                className={`${
                                    productId == element?.id ? "checked" : ""
                                } radioBtn `}
                            ></span> */}
              <p>{element?.title}</p>
            </VariantTitle>
            <VariantData>
              {element?.variantFeature?.length
                ? element?.variantFeature?.map((innerElement, index) => {
                    return (
                      <li key={`feature${index}`}>{innerElement.feature}</li>
                    );
                  })
                : null}
              <p className="mrpPrice">₹{element?.price}&nbsp;</p>
              <div className="priceInfo">
                {!hideStrikeprice ? (
                  <>
                    <StrikePrice health={true}>
                      ₹{element?.strikePrice}
                    </StrikePrice>
                    &nbsp;
                    <DiscountStyle>{discountPercent}% Off</DiscountStyle>
                  </>
                ) : null}
              </div>
              {/* <p className="inclusive">
                                {"(incl. of all taxes)"}
                            </p> */}
              <p className="pricePerUnit">{element?.pricePerUnit}</p>
            </VariantData>
            {element?.id == '3663' ? (
              <VariantTag isFertilityProduct={isFertilityProduct}>
                <p>Bestseller</p>
              </VariantTag>
            ) : null}
          </>
        ) : lactoMamaCategory ? (
          <>
            <PackInfo>
              <TitleWrapper selected={productId === element?.id}>
                <p>{element?.title}</p>
                <div>{element?.subText}</div>
              </TitleWrapper>

              <div className="gridLayout">
                {mobileView ? <div>{getVariantFeatures('top')}</div> : null}

                <div className="imageOuter">
                  <Image
                    src={element?.image_path || element?.image}
                    alt={element?.title}
                    className="image"
                    quality={90}
                    fill
                    sizes="33vw"
                  />
                </div>
                <div className="gridInner">
                  {!mobileView ? <div>{getVariantFeatures('side')}</div> : null}

                  <div className="extraPadding">
                    <Price>
                      ₹{productPriceData?.price || element?.price}
                      &nbsp;
                    </Price>
                    <PackPrice>
                      {!hideStrikeprice ? (
                        <>
                          <StrikePrice>
                            ₹
                            {productPriceData?.strikeprice ||
                              element?.strikePrice}
                          </StrikePrice>
                          &nbsp;
                          <DiscountStyle>{discountPercent}% Off</DiscountStyle>
                        </>
                      ) : (
                        <p>M.R.P.</p>
                      )}
                    </PackPrice>
                    {(lactoMama || lactoMamaCategory) && !stretchMarks ? (
                      <PPUText>
                        <p>
                          <b>{productPriceData?.ppuText || element?.ppuText}</b>{' '}
                          {'/ 100 g'}
                        </p>
                      </PPUText>
                    ) : null}
                  </div>
                </div>
              </div>
            </PackInfo>
            {element?.id == '3928' || element?.id == '979' ? (
              <VariantTag isFertilityProduct={isFertilityProduct}>
                <p>Bestseller</p>
              </VariantTag>
            ) : null}
          </>
        ) : (
          <>
            <PackInfo>
              <TitleWrapper selected={productId === element?.id}>
                {isDetergentProduct ? (
                  <p>{element?.variantFeature?.[0]?.feature}</p>
                ) : (
                  <p>{element?.title}</p>
                )}
              </TitleWrapper>
              {!isDetergentProduct && (
                <div className="variantFeature">
                  {element?.variantFeature?.length
                    ? element?.variantFeature?.map((innerElement, index) => {
                        return (
                          <li key={`feature${index}`}>
                            {innerElement.feature}
                          </li>
                        );
                      })
                    : null}
                </div>
              )}

              <div className="imageOuter">
                <Image
                  src={element?.image_path || element?.image}
                  alt={element?.title}
                  className="image"
                  quality={90}
                  fill
                  sizes="33vw"
                />
              </div>
              <div className="extraPadding">
                <Price>
                  ₹{productPriceData?.price || element?.price}
                  &nbsp;
                </Price>
                <PackPrice>
                  {!hideStrikeprice ? (
                    <>
                      <StrikePrice>
                        ₹{productPriceData?.strikeprice || element?.strikePrice}
                      </StrikePrice>
                      &nbsp;
                      <DiscountStyle>{discountPercent}% Off</DiscountStyle>
                    </>
                  ) : (
                    <p>M.R.P.</p>
                  )}
                </PackPrice>
                {lactoMama ? (
                  <PPUText>
                    <p>
                      <b>{productPriceData?.ppuText || element?.ppuText}</b> /
                      100 g
                    </p>
                  </PPUText>
                ) : null}
              </div>
            </PackInfo>
            {element?.id == '3928' || element?.id == '3907' ? (
              <VariantTag isFertilityProduct={isFertilityProduct}>
                <p>Bestseller</p>
              </VariantTag>
            ) : null}
          </>
        )}
      </BundleContainer>
    </Link>
  );
}

export default HealthBundleInner;
